import type { Novidade } from './tipos';

/** Fase 2, W10: módulo Tarefas (kanban de demandas, painel de medição e aprovação só pela pessoa). */
export const novidadeTarefas: Novidade = {
  id: '2026-10-05-tarefas',
  publicada_em: '2026-10-05',
  tipo: 'novo',
  modulo: 'tarefas',
  permissao: 'tarefas.ver',
  textos: {
    pt: {
      titulo: 'Tarefas: o kanban das demandas',
      resumo: 'Cada pedido de mudança no sistema vira um card, do pedido à publicação, com métricas do fluxo.',
      passos: [
        'Em Operação, Tarefas, o quadro Demandas MalgoOS mostra cada card da Entrada ao Publicado.',
        'Arraste o card ou use o teclado: Espaço pega, as setas movem e Espaço solta.',
        'Em construção e Publicado exigem a sua aprovação, na sua sessão. Agente e chave de API nunca aprovam.',
        'O Painel mostra lead time, gargalo, tempo esperando decisão e a previsão por tamanho.',
      ],
    },
    en: {
      titulo: 'Tasks: the requests kanban',
      resumo: 'Every change request becomes a card, from the request to publishing, with flow metrics.',
      passos: [
        'In Operations, Tasks, the MalgoOS Requests board shows each card from Inbox to Published.',
        'Drag the card or use the keyboard: Space picks it up, the arrows move it and Space drops it.',
        'In development and Published require your approval, in your own session. Agents and API keys never approve.',
        'Metrics shows lead time, the bottleneck, time waiting for decisions and the forecast by size.',
      ],
    },
    es: {
      titulo: 'Tareas: el kanban de las demandas',
      resumo: 'Cada pedido de cambio en el sistema se vuelve una tarjeta, del pedido a la publicación, con métricas del flujo.',
      passos: [
        'En Operación, Tareas, el tablero Demandas MalgoOS muestra cada tarjeta de la Entrada al Publicado.',
        'Arrastra la tarjeta o usa el teclado: Espacio la toma, las flechas la mueven y Espacio la suelta.',
        'En construcción y Publicado exigen tu aprobación, en tu sesión. El agente y la clave de API nunca aprueban.',
        'El Panel muestra el lead time, el cuello de botella, el tiempo esperando decisión y la previsión por tamaño.',
      ],
    },
  },
  imagens: ['/novidades/2026-10-05-tarefas/kanban.webp', null, null, null],
  treinamento: { curso: 'novidades' },
  rota: '/operacao/tarefas/kanban',
};
